import SessionService from 'ember-simple-auth/services/session';

export default SessionService;
